import { render, staticRenderFns } from "./True.vue?vue&type=template&id=2fd90e23&scoped=true&"
import script from "./True.vue?vue&type=script&lang=js&"
export * from "./True.vue?vue&type=script&lang=js&"
import style0 from "./True.vue?vue&type=style&index=0&id=2fd90e23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd90e23",
  null
  
)

export default component.exports